import { checkValue, hasYesOrNo } from 'models/validate';
import cityCountry from 'forms/shared/validators/models/location/models/cityCountry';
import name from 'forms/shared/validators/models/name/name';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { DateBaseValidatorOptions } from 'forms/shared/validators/base/date/types';
import { CitizenshipForeignPassportsItemModel } from '../types';
import { citizenshipForeignPassportsTravelValidator } from './travel';

export const citizenshipForeignPassportsItemValidator: ValidateJSModel<CitizenshipForeignPassportsItemModel> = {
  Has: {},
  Comments: {},
  CountriesComments: {},
  UsedComments: {},

  Country: (value, attributes) => {
    if (attributes?.CountryFocused) {
      return {};
    }

    return { hasValue: true, country: { excludeUnitedStates: true } };
  },

  Issued: (value, attributes, attributeName, options = {}) => {
    const { applicantBirthdate } = options;
    return {
      presence: true,
      date: { earliest: applicantBirthdate, latest: DEFAULT_LATEST },
    };
  },

  Location: {
    presence: true,
    location: { validator: cityCountry },
  },

  Name: {
    presence: true,
    model: { validator: name },
  },

  Number: { presence: true, hasValue: true },

  Expiration: (value, attributes) => {
    const dateLimits: DateBaseValidatorOptions = {};
    if (attributes?.Issued) {
      dateLimits.earliest = attributes?.Issued;
      dateLimits.tooEarly = 'error.passport.expiration.min';
    }
    return { presence: true, date: dateLimits };
  },

  Used: { presence: true, hasValue: { validator: hasYesOrNo } },
  Countries: (value, attributes) => (checkValue(attributes?.Used, 'Yes')
    ? {
      presence: true,
      accordion: {
        validator: citizenshipForeignPassportsTravelValidator,
        ignoreBranch: true,
      },
    }
    : {}),
};
